/**
 * The reference implementation's panel chrome, transplanted verbatim.
 *
 * `ErrorState` and the loading state are not here: the portal renders both
 * around the custom component, and a report cannot reach this file before its
 * payload has arrived.
 */

import type { ReactNode } from 'react'

interface CardProps {
  title: string
  // `| undefined` explicitly, because `exactOptionalPropertyTypes` distinguishes
  // "absent" from "present and undefined" and the callers pass the latter.
  subtitle?: string | undefined
  actions?: ReactNode
  children: ReactNode
}

export function Card({ title, subtitle, actions, children }: CardProps) {
  return (
    <section className="card">
      <header className="card-header">
        <div>
          <h2 className="card-title">{title}</h2>
          {subtitle !== undefined && <p className="card-subtitle">{subtitle}</p>}
        </div>
        {actions}
      </header>
      {children}
    </section>
  )
}

export function Empty({ label }: { label: string }) {
  return <div className="state">{label}</div>
}
